module.exports = __webpack_public_path__ + "img/dcms05.d2f1a282.png";